import React from 'react'

const Evolution = ({pokemon}) => {

    return (
        <div>
            <h1>Evolution</h1>
        </div>
    )
}

export default Evolution
